import React from "react";
import {Route, Router, Switch} from "react-router-dom";
import {Provider} from "react-redux";
import { createBrowserHistory } from "history";

import store from "./store";
import {
  ROUTER_IMAGE,
  ROUTER_IMAGE_DETAIL,
  ROUTER_MEMBERS,
  ROUTER_MEMBERS_DELETE_RELATION,
  ROUTER_MEMBERS_INVITE,
  ROUTER_MESSAGE,
  ROUTER_MESSAGE_SENIOR,
  ROUTER_MESSAGE_SENIOR_IMAGE,
  ROUTER_ROOT,
  ROUTER_TIMELINE,
  ROUTER_USER_DELETE,
  ROUTER_USER_LOGIN,
  ROUTER_USER_PASSWORD_NEW,
  ROUTER_USER_PASSWORD_REQUEST,
  ROUTER_USER_REGISTER,
  ROUTER_VIDEO,
  ROUTER_DOWNLOADS,
} from "./shared/constants/routers";
import authorize from "./shared/components/Authorization";
// User
import Login from "./screens/user/loginContainer";
import SignUp from "./screens/user/signupContainer";
import RequestPassword from "./screens/user/requestPasswordContainer";
import SetPassword from "./screens/user/setPasswordContainer";
import Delete from "./screens/user/deleteContainer";
import Downloads from "./screens/user/downloads";
// Timeline
import Timeline from "./screens/timeline/timelineContainer";
// Members
import Members from "./screens/members/membersContainer";
import Invite from "./screens/members/inviteContainer";
import DeleteRelation from "./screens/members/deleteRelationContainer";
// Message
import MessageSeniorList from "./screens/message/seniorListContainer";
import MessageBoard from "./screens/message/messageContainer";
import ImageMessage from "./screens/message/imageContainer";
// Image
import ImageView from "./screens/image/imageViewContainer";
import ImageUpload from "./screens/image/imageUploadContainer";
// Video
import Video from "./screens/video/videoContainer";
// System
import NotFound from "./shared/containers/NotFound";

/**
 * Checks if app is cordova based
 * @returns {boolean} if app is cordova based
 */
export const isCordova = () => {
  // noinspection JSUnresolvedVariable
  return typeof (cordova) === "object";
};

export const history = createBrowserHistory();

/**
 * App
 * @returns {*} provider
 * @constructor
 */
export const App = () => (
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={ROUTER_ROOT}
          name="app"
          component={authorize(Timeline)}
        />
        {/* TimeLine */}
        <Route
          exact
          path={ROUTER_TIMELINE}
          name="timeline"
          component={authorize(Timeline)}
        />
        {/* User */}
        <Route
          exact
          path={ROUTER_USER_LOGIN}
          name="login"
          component={Login}
        />
        <Route
          exact
          path={ROUTER_USER_REGISTER}
          name="register"
          component={SignUp}
        />
        <Route
          exact
          path={ROUTER_USER_PASSWORD_REQUEST}
          name="password_request"
          component={RequestPassword}
        />
        <Route
          exact
          path={ROUTER_USER_PASSWORD_NEW}
          name="new_password"
          component={SetPassword}
        />
        <Route
          exact
          path={ROUTER_USER_DELETE}
          name="delete_account"
          component={authorize(Delete)}
        />
        <Route
          exact
          path={ROUTER_DOWNLOADS}
          name="downloads"
          component={Downloads}
        />
        {/* Memebrs */}
        <Route
          exact
          path={ROUTER_MEMBERS}
          name="members"
          component={authorize(Members)}
        />
        <Route
          exact
          path={ROUTER_MEMBERS_INVITE}
          name="members_invite"
          component={authorize(Invite)}
        />
        <Route
          exact
          path={ROUTER_MEMBERS_DELETE_RELATION}
          name="members_delete_relation"
          component={authorize(DeleteRelation)}
        />
        {/* Image */}
        <Route
          exact
          path={ROUTER_IMAGE_DETAIL}
          name="image_detail"
          component={authorize(ImageView)}
        />
        <Route
          exec
          path={ROUTER_IMAGE}
          name="image"
          component={authorize(ImageUpload)}
        />
        {/* Message */}
        <Route
          exact
          path={ROUTER_MESSAGE}
          name="message"
          component={authorize(MessageSeniorList)}
        />
        <Route
          exact
          path={ROUTER_MESSAGE_SENIOR}
          name="message_senior"
          component={authorize(MessageBoard)}
        />
        <Route
          exact
          path={ROUTER_MESSAGE_SENIOR_IMAGE}
          name="message_senior_image"
          component={authorize(ImageMessage)}
        />
        {/* Video */}
        <Route
          exact
          path={ROUTER_VIDEO}
          name="video"
          component={authorize(Video)}
        />
        {/* System */}
        <Route component={NotFound}/>
      </Switch>
    </Router>
  </Provider>
);
